import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { CalendarClock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (d) => (d ? `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}` : "—");
const daysLeft = (d) => (d ? Math.ceil((new Date(d) - new Date()) / 86400000) : null);

/** Dashboard: preorder articles with reserved pieces, customers and remaining stock. */
export const PreordersWidget = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    axios.get(`${API}/dashboard/preorders`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("access_token")}` } })
      .then((r) => setRows(r.data.preorders || []))
      .catch(() => setRows([]));
  }, []);

  return (
    <Card data-testid="preorders-widget">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2"><CalendarClock className="w-4 h-4 text-amber-500" /> Prevendite in corso</CardTitle>
        <p className="text-xs text-gray-500">Pezzi prenotati dai clienti (ordini non annullati) e pezzi ancora disponibili</p>
      </CardHeader>
      <CardContent>
        {rows === null ? (
          <p className="text-sm text-gray-400">Caricamento…</p>
        ) : rows.length === 0 ? (
          <p className="text-sm text-gray-400" data-testid="preorders-empty">Nessun articolo in prevendita al momento.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="preorders-table">
              <thead>
                <tr className="text-left text-xs uppercase tracking-wide text-gray-500 border-b">
                  <th className="py-2 pr-2">Articolo</th>
                  <th className="py-2 px-2">Uscita</th>
                  <th className="py-2 px-2 text-right">Prenotati</th>
                  <th className="py-2 px-2 text-right">Clienti</th>
                  <th className="py-2 pl-2 text-right">Restano</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => {
                  const dl = daysLeft(r.preorder_date);
                  const total = r.reserved + r.stock;
                  const pct = total ? Math.round((r.reserved / total) * 100) : 0;
                  return (
                    <tr key={r.id} className="border-b last:border-0 align-top" data-testid={`preorder-row-${r.id}`}>
                      <td className="py-2.5 pr-2">
                        <div className="flex items-center gap-2">
                          {r.image && <img src={r.image} alt="" className="w-9 h-9 object-contain rounded bg-gray-100" />}
                          <div>
                            <div className="font-medium text-gray-900 leading-tight">{r.title}</div>
                            <div className="h-1.5 w-32 bg-gray-200 rounded-full mt-1.5"><div className="h-1.5 bg-amber-400 rounded-full" style={{ width: `${pct}%` }} /></div>
                            <div className="text-[10px] text-gray-400 mt-0.5">{pct}% dei pezzi già prenotati</div>
                          </div>
                        </div>
                      </td>
                      <td className="py-2.5 px-2 whitespace-nowrap">
                        <div className="font-medium">{fmt(r.preorder_date)}</div>
                        {dl !== null && <div className={`text-[11px] ${dl <= 3 ? "text-red-600 font-bold" : "text-gray-500"}`}>{dl > 0 ? `tra ${dl} giorni` : dl === 0 ? "oggi" : "uscito"}</div>}
                      </td>
                      <td className="py-2.5 px-2 text-right font-bold text-amber-600" data-testid={`preorder-reserved-${r.id}`}>{r.reserved}</td>
                      <td className="py-2.5 px-2 text-right text-gray-700" data-testid={`preorder-customers-${r.id}`}>{r.customers}</td>
                      <td className={`py-2.5 pl-2 text-right font-bold ${r.stock <= 2 ? "text-red-600" : "text-green-700"}`} data-testid={`preorder-stock-${r.id}`}>{r.stock}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
